import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['select', 'match']

  connect() {
    this.change();
  }

  change() {
    console.log(this.selectTarget.value);
    this.matchTargets.forEach((target) => {
      if (target.dataset.value.split(' | ').includes(this.selectTarget.value)) {
        target.classList.remove('hidden');
        target.querySelectorAll('input,select,textarea').forEach((input) => {
          input.removeAttribute('disabled');
        });
        // Re-trigger nested checkbox-toggle so it can re-disable inputs we just blanket-enabled.
        target.querySelectorAll('[data-target="checkbox-toggle.checkbox"]').forEach((checkbox) => {
          checkbox.dispatchEvent(new Event('change'));
        });
      } else {
        target.classList.add('hidden');
        target.querySelectorAll('input,select,textarea').forEach((input) => {
          input.setAttribute('disabled', 'disabled');
        });
      }
    });
  }
}
